import { render, staticRenderFns } from "./RecMaterials.vue?vue&type=template&id=045cbf78&scoped=true"
import script from "./RecMaterials.vue?vue&type=script&lang=js"
export * from "./RecMaterials.vue?vue&type=script&lang=js"
import style0 from "./RecMaterials.vue?vue&type=style&index=0&id=045cbf78&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "045cbf78",
  null
  
)

export default component.exports